export const EMAIL_REGEX = /^[\w+.-]+@[\da-z-]+(\.[\da-z-]+)*\.[a-z]+$/i;
